export default __webpack_public_path__ + "static/media/SKS_Past_History.2bb1cb3f.svg";